import SolutionCard from "../../reusables/SolutionCard";
import networking from "../../../assets/images/solutions-icon/networking.svg";

const NetworkingSolution = () => {
  return (
    <SolutionCard
      icon={networking}
      title="Networking & Infrastructure"
      subtitle="Design and deployment of reliable and secure network systems"
      ctaLink="/solutions/networking"
    />
  );
};

export default NetworkingSolution;
